import {of as observableOf,  Observable } from 'rxjs';
import {map, catchError, switchMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as Action from '../store/actions';
import { ChannelsService } from '../channels.service';
import {LoggingService} from "../../../shared/logging.service";

@Injectable()
export class Effects {

    /* Retrieve all channels from current user */

    @Effect()
    requestChannels: Observable<Action.RequestChannelsFailure | Action.RequestChannelsSuccess> = this.actions$.pipe(
        ofType(Action.REQUEST_CHANNELS),
        switchMap((action: Action.RequestChannels) => {
          return this.channelsService.getChannels().pipe(map((channels) => {
            return new Action.RequestChannelsSuccess(channels);
          }),
          catchError(e => {
            return observableOf(new Action.RequestChannelsFailure(e));
          }),);
        }));

    /* Update a channel */

    @Effect()
    updateChannel: Observable<Action.UpdateChannelFailure | Action.UpdateChannelSuccess> = this.actions$.pipe(
        ofType(Action.UPDATE_CHANNEL),
        switchMap((action: Action.UpdateChannel) => {
          return this.channelsService.updateChannels(action.payload).pipe(map((channels) => {
            this.log.Action("update-channel", {alert:action.payload})
            return new Action.UpdateChannelSuccess(action.payload);
          }),
          catchError(e => {
            return observableOf(new Action.UpdateChannelFailure(e));
          }),);
        }));


    /* Test a channel */

    @Effect()
    testChannel: Observable<Action.TestChannelFailure | Action.TestChannelSuccess> = this.actions$.pipe(
        ofType(Action.TEST_CHANNEL),
        switchMap((action: Action.TestChannel) => {
          return this.channelsService.testChannel(action.payload).pipe(map((channels) => {
            this.log.Action("test-channel", {alert:action.payload})
            return new Action.TestChannelSuccess(action.payload);
          }),
          catchError(e => {
            return observableOf(new Action.TestChannelFailure(e));
          }),);
        }));

    constructor(private channelsService: ChannelsService,
                private actions$: Actions,
                private log: LoggingService) {}
}
